module.exports = __webpack_public_path__ + "media/images/bclogoicon-bbebd300.gif";